import { mixGetV1, mixPostV1, mixPutV1, mixDelV1 } from '../services/mixin';

export interface BranchItem {
    id: number;
    name: string;
    address: string;
    city: string;
    district: string;
    ward: string;
    email: string | null;
    phone: string | null;
    status: number;
    created_at: string;
    updated_at: string;
    deleted_at: string | null;
}

export interface BranchListParams {
    search?: string;
    status?: number;
    city?: string;
    page?: number;
}

export interface BranchCreateParams {
    name: string;
    address?: string;
    city?: string;
    ward?: string;
    email?: string;
    phone?: string;
    status?: number;
}

export interface BranchUpdateParams {
    name: string;
    address?: string;
    city?: string;
    ward?: string;
    email?: string;
    phone?: string;
    status?: number;
}

export const getBranches = async (params: BranchListParams = {}) => {
    return mixGetV1('/api/v1/be/branches', params);
};

export const getBranchById = async (id: number) => {
    return mixGetV1(`/api/v1/be/branches/${id}`);
};

export const createBranch = async (data: BranchCreateParams) => {
    return mixPostV1('/api/v1/be/branches', data);
};

export const updateBranch = async (id: number, data: BranchUpdateParams) => {
    return mixPutV1(`/api/v1/be/branches/${id}`, data);
};

export const deleteBranch = async (id: number) => {
    return mixDelV1(`/api/v1/be/branches/${id}`, {});
};
